module.exports = __webpack_public_path__ + "img/figmaPage.9971092d.jpg";